import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AXNUIErrorPage } from '@iddataweb/idw-common-ui/containers';
import { AxnuiErrorCodeTypes } from '@iddataweb/idw-common-ui/enums';
import {
    getFormPanelLayout,
    getFormPanelTheme,
    getIDPName,
    getLogoPosition,
    getLogoUrl,
    getPageTitle,
    getRPName
} from '@redux/selectors/verification-configuration-selectors';
import { getLanguageContent } from "@redux/selectors/language-selectors";
import { getQueryParametersASI, getQueryParametersErrorCode, getQueryParametersReferenceId } from '@redux/selectors/query-parameters-selectors';
import { getErrorState } from "@redux/selectors/error-selectors";
import { setSubmissionFailed } from '@redux/actions/submission-actions';

type ErrorPageProps = {
    useThemedUI: boolean;
};

export const ErrorPage = (props: ErrorPageProps) => {
    const { useThemedUI } = props;
    const dispatch = useDispatch();
    const pageTitle = useSelector(getPageTitle);
    const content = useSelector(getLanguageContent);
    const idpName = useSelector(getIDPName);
    const relyingPartyName = useSelector(getRPName);
    const logoUrl = useSelector(getLogoUrl);
    const logoPosition = useSelector(getLogoPosition);
    const formPanelTheme = useSelector(getFormPanelTheme);
    const formPanelLayout = useSelector(getFormPanelLayout);
    const queryParametersErrorCode = useSelector(getQueryParametersErrorCode) as AxnuiErrorCodeTypes;
    const errorState = useSelector(getErrorState);
    const queryParametersASI = useSelector(getQueryParametersASI);
    const queryParametersReferenceId = useSelector(getQueryParametersReferenceId);

    useEffect(() => {
        dispatch(setSubmissionFailed(true));
    }, []);

    useEffect(() => {
        document.title = pageTitle;
    }, [pageTitle]);

    return (
        <AXNUIErrorPage
            asi={queryParametersASI}
            content={content}
            errorCode={queryParametersErrorCode}
            errorMessage={errorState.message}
            formPanelLayout={formPanelLayout}
            formPanelTheme={formPanelTheme}
            idpName={idpName}
            logoPosition={logoPosition}
            logoUrl={logoUrl}
            referenceId={queryParametersReferenceId}
            relyingPartyName={relyingPartyName}
            useThemedUI={useThemedUI}
        />
    );
};